"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backdrop = exports.root = void 0;
var react_1 = require("@emotion/react");
var root = function (open, exited) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: 1000;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  ", ";\n"], ["\n  position: fixed;\n  z-index: 1000;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  ", ";\n"])), !open && exited && 'visibility: hidden'); };
exports.root = root;
exports.backdrop = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: -1;\n"], ["\n  z-index: -1;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=Modal.style.js.map